import type { UserSessionDto } from '../../react/features/SessionManager/types';
import { get, remove } from '../request';

const BASE_URL = '/api/v2/session-manager';

getAllSessions.operation = 'READ';
export function getAllSessions(userId: String): Promise<UserSessionDto[]> {
    return get<UserSessionDto[]>(`${BASE_URL}/${userId}/sessions`).then(res =>
        res.map(s => ({
            ...s,
            id: `${s.userId}:${s.shortToken}`, // Needed for Ladda cache control
            expiresAt: new Date(s.expiresAt),
            signedIn: new Date(s.signedIn),
        }))
    );
}

revoke.operation = 'DELETE';
export function revoke(id /* For Ladda cache control */ : String, userId: string, shortToken: string): Promise<void> {
    return remove(`${BASE_URL}/${userId}/sessions/${shortToken}`);
}
